// Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin,
// CustomEase, DrawSVGPlugin, ScrollSmoother, GSDevTools, InertiaPlugin,
// MorphSVGPlugin, MotionPathHelper, SplitText, CustomBounce, CustomWiggle,
import { DrawSVGPlugin, gsap, GSDevTools, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, GSDevTools);
export default () => {
  let mm = gsap.matchMedia();
  //------------------------------------------------------//
  // Setup 🧦 GSAP and register 📜 ScrollTrigger
  // Register more plugins like so: gsap.registerPlugin(ScrollTrigger,
  // splitText); Go to
  // https://greensock.com/docs/v3/Installation?checked=core,scrollTrigger,splitText#installer
  //------------------------------------------------------//
  // gsap.registerPlugin(Flip, ScrollTrigger, Observer, ScrollToPlugin,
  // Draggable, MotionPathPlugin, CustomEase, DrawSVGPlugin, ScrollSmoother,
  // GSDevTools, InertiaPlugin, MorphSVGPlugin, MotionPathHelper, SplitText,
  // CustomBounce, CustomWiggle);

  ScrollTrigger.defaults({
    toggleActions: 'restart pause resume pause',
    markers: window.location.hostname.endsWith('.local') ? true : false
  });

  // END Setup 🧦 GSAP -------------------------------------//
  //--------------------------------//
  // 404 page
  //--------------------------------//
  if (document.querySelector('.error404')) {
    const tl = gsap.timeline({});
    gsap.set('.one path', {
      drawSVG: '0% 25%'
    });
    gsap.set('.two path', {
      drawSVG: '75% 100%'
    });
    tl.to('.shape-404 .one path', {
      drawSVG: '100% 125%',
      ease: 'none',
      duration: 10,
      repeat: -1
    });
    tl.to(
      '.shape-404 .two path',
      {
        drawSVG: '175% 200%',
        ease: 'none',
        duration: 10,
        repeat: -1
      },
      '<'
    );
  }
  // END 404 page --------------//
  //--------------------------------//
  // Our story
  //--------------------------------//

  document.querySelectorAll('.ACF-our_story.type-fancy').forEach(container => {
    const q = gsap.utils.selector(container);
    const duration = 1;
    const stagger = duration * 2;
    const tl = gsap.timeline({
      defaults: { ease: 'none' },
      scrollTrigger: {
        trigger: container,
        start: 'center center',
        scrub: true,
        end: `center+=${window.innerHeight * (container.dataset.count - 1)} center`,
        snap: 1 / (container.dataset.count - 1),
        pin: 'main',
        // pin: true,
        anticipatePin: true,
        markers: true
      }
    });

    // Animate in  --------------------------------------------------- //
    tl.from(q('.overview li:not(:first-child) .alloy-item'), {
      y: () => window.innerHeight / 2,
      opacity: 0,
      duration: duration,
      stagger: stagger
    });
    tl.from(
      q('.overview li:not(:first-child) .alloy-item .image'),
      {
        rotationX: -15,
        scale: 0.8,
        duration: duration,
        stagger: stagger
      },
      '<'
    );

    tl.from(
      q('.overview li:not(:first-child) .alloy-item .year'),
      {
        rotationX: 15,
        scale: 1.2,
        duration: duration,
        stagger: stagger
      },
      '<'
    );

    // Animate out  --------------------------------------------------- //
    tl.to(
      q('.overview li:not(:last-child) .alloy-item'),
      {
        y: () => -window.innerHeight / 2,
        opacity: 0,
        duration: duration,
        stagger: stagger
      },
      '<'
    );
    tl.to(
      q('.overview li:not(:last-child) .alloy-item .image'),
      {
        rotationX: 15,
        scale: 0.8,
        duration: duration,
        stagger: stagger
      },
      '<'
    );

    tl.to(
      q('.overview li:not(:last-child) .alloy-item .year'),
      {
        rotationX: -15,
        scale: 0.8,
        duration: duration,
        stagger: stagger
      },
      '<'
    );
  });
  // END Our story --------------//
};
